export function formatInputTime(input: string): string {
  const cleanedInput = input.replace(/[^\d:]/g, '');
  let result = '';
  let colonInserted = false;

  for (let i = 0; i < cleanedInput.length; i++) {
    const char = cleanedInput[i];

    if (char === ':' && result.length === 2 && !colonInserted) {
      result += ':';
      colonInserted = true;
      continue;
    }

    if (char >= '0' && char <= '9') {
      if (result.length === 0) {
        if (parseInt(char, 10) <= 2) {
          result += char;
        }
      } else if (result.length === 1) {
        const hours = parseInt(result + char, 10);
        if (hours <= 23) {
          result += char;
        }
      } else if (result.length === 2 && !colonInserted) {
        result += ':';
        colonInserted = true;
        result += char;
      } else if (result.length === 3) {
        if (parseInt(char, 10) <= 5) {
          result += char;
        }
      } else if (result.length === 4) {
        if (parseInt(char, 10) <= 9) {
          result += char;
        }
      }
    }
  }

  return result;
}
